export default __webpack_public_path__ + "static/media/banner-web-iq4.3e679d70.png";